import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages(
    'pages.RequestFormPage.XeroAirwallexBatchPaymentForm.BillsInformation.AddBeneficiaryPopup',
    {
        popupTitle: 'Create beneficiary',
        nextStepButtonText: 'NEXT',
        prevStepButtonText: 'BACK',
        createButtonText: 'CREATE',
        unknownError: 'Unknown error',
        notSupported: 'Not supported. Please try a different combination.',
        notSupportedCurrency: 'Airwallex does not support the currency of the bill ({currency}).',
        twoFaPopupTitle: 'Complete beneficiary creation via the Authenticator app',
        confirmationPopupTitle: 'Unsaved changes',
        confirmationPopupDescription:
            'There are unsaved changes on the page. Would you like to discard them or continue editing?',
        cancelButtonText: 'Discard Changes',
        cancelButtonTitle: 'Discard unsaved changes',
        confirmButtonText: 'Continue Editing',
        confirmButtonTitle: 'Stay on this page and continue editing',
    }
);
